document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        const formEmbed = document.querySelector("form-embed");
        if (formEmbed) {
            const shadowRoot = formEmbed.shadowRoot;
            if (shadowRoot) {
                const style = document.createElement("style");
                style.textContent = `
                h2 {
                    font-family: Recoleta !important;
                }
                p,
                span,
                button,
                a,
                div,
                input,
                input::placeholder {
                    font-family: "Aktiv Grotesk" !important;
                }
                a {
                    color: rgb(32, 32, 32) !important;
                }
                
                button {
                    font-size: 14px !important;
                    font-weight: 400 !important;
                    letter-spacing: 1.4px !important;
                }

                `;
                shadowRoot.appendChild(style);
            }
        }
    }, 1500);
});
